import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  private commonSub$: BehaviorSubject<any> = new BehaviorSubject(null);
  onlyNumber(e: any) {
    if ((e.charCode < 48 || e.charCode > 57))
      return false;
    return true;
  }

  public static clone(jsonObject: object) {
    return JSON.parse(JSON.stringify(jsonObject));
  }

  public static convertUTCDate(convertdate: any) {
    return new Date(new Date(convertdate).toLocaleDateString() + 'UTC');
  }
  getProfileObs(): Observable<any> {
    return this.commonSub$.asObservable();
  }

  setProfileObs(obj: any) {
    this.commonSub$.next(obj);
  }

  public convertTime24to12(time24h: any): any {
    var timex = time24h.split(':');
    timex[0] = timex[0].split(' ').length > 1 ? timex[0].split(' ')[1] : timex[0];
    if (timex[0] !== undefined && timex[1] !== undefined) {
      var hor = parseInt(timex[0]) > 12 ? (parseInt(timex[0]) - 12) : timex[0];
      var minu = timex[1];
      var merid = parseInt(timex[0]) < 12 ? 'PM' : 'AM';
      return hor + ':' + minu + ' ' + merid;


    }
  }

  public convertUTCDateTime(convertdate) {
    if (convertdate && convertdate != '')
      return new Date(Date.UTC(new Date(convertdate).getFullYear(), new Date(convertdate).getMonth(), new Date(convertdate).getDate(), new Date(convertdate).getHours(), new Date(convertdate).getMinutes(), 0, 0));
    else
      return convertdate;
  }

  public isNumericNull(value: any): number {
    return (value == null || value == undefined) ? 0 : value;
  }
  public isDateNull(value: any): Date {
    return (value == null || value == undefined) ? new Date('1/1/1999') : value;
  }
  public isStringNull(value: any): string {
    return (value == null || value == undefined) ? '' : value.trim();
  }
  public isDateStringNull(value: any): string {
    return (value == null || value == undefined || value =='1900-01-01') ? '' : value;
  }
  public ArrayToCommaSeperator(value: any): string {
    let stRtn = '';
    if (value != null && value != undefined) {
      //for (var i = 0; i < value.length; i++) {
      //  stRtn += value[i];
      //}
      //stRtn = stRtn.replace(/,\s*$/, "");
      stRtn = value.toString();
    }
    return stRtn;
  }
  public CommaSeperatorToArray(value: string): any {

    if (value != null && value != undefined && value != '' && value.indexOf(",") > 0) {

      return value.split(',');
    }
    else if (value != null && value != '') {
      let inpUno: number[] = [];
      inpUno.push(parseInt(value))
      return inpUno;
    }
    else if (value == null || value == undefined || value == '') {
      return [];
    }


    return value;
  }
  public getnodataImage() {

    var d = new Date();
    let n = d.getMilliseconds();
    let rndnumber = (n >= 0 && n <= 55) ? 1 : (n >= 56 && n <= 93) ? 2 : (n >= 94 && n <= 150) ? 2 : (n >= 151 && n <= 200) ? 3 :
      (n >= 201 && n <= 250) ? 4 : (n >= 251 && n <= 349) ? 5 : (n >= 350 && n <= 445) ? 6 : (n >= 446 && n <= 525) ? 7 : (n >= 526 && n <= 610) ? 8 :
        (n >= 611 && n <= 720) ? 9 : (n >= 721 && n <= 790) ? 10 : (n >= 791 && n <= 850) ? 11 : (n >= 851 && n <= 950) ? 12 : 1;
    switch (rndnumber) {
      case 1:
        return "assets/v2/img/no-data-image/no-data.jpg";
      case 2:                              
        return "assets/v2/img/no-data-image/no-data.jpg";
      case 3:                              
        return "assets/v2/img/no-data-image/no-data.jpg";
      case 4:                              
        return "assets/v2/img/no-data-image/no-data.jpg";
      case 5:                              
        return "assets/v2/img/no-data-image/no-data.jpg";
      case 6:                              
        return "assets/v2/img/no-data-image/no-data.jpg";
      case 7:                              
        return "assets/v2/img/no-data-image/no-data.jpg";
      case 8:                              
        return "assets/v2/img/no-data-image/no-data.jpg";
      case 9:                               
        return "assets/v2/img/no-data-image/no-data.jpg";
      case 10:                             
        return "assets/v2/img/no-data-image/no-data.jpg";
      case 11:                              
        return "assets/v2/img/no-data-image/no-data.jpg";
      case 12:                              
        return "assets/v2/img/no-data-image/no-data.jpg";

      default:
        return "assets/v2/img/no-data-image/no-data.jpg";

    }

  }

  public removeHTMLTags(value) {
    if ((value === null) || (value === ''))
      return value = '';
    else
      return value.replace(/(<([^>]+)>)/ig, '');
  }


}



